import { FC } from 'react';
import { LabelTransformer, DiffBase, DiffBaseProps } from '../diff-base';
import * as Styled from './employee-dto-candidate-preoffer-info-diff.styles';
import { useTranslation } from 'react-i18next';
import { EmployeeDtoCandidatePreofferInfoDataFields } from '@innowise-group/core';
import { localizedNameObject } from '@innowise-group/utilities';

interface EmployeeDtoCandidatePreofferInfoDiff extends Omit<DiffBaseProps, 'labelTransformer'> {
  fieldName: EmployeeDtoCandidatePreofferInfoDataFields;
}

const EmployeeDtoCandidatePreofferInfoDiff: FC<EmployeeDtoCandidatePreofferInfoDiff> = (props) => {
  const { fieldName } = props;
  const labelTransformer: LabelTransformer<typeof fieldName> = ({ data }, index) => {
    const { t } = useTranslation();

    return (
      <Styled.OptionWrapper key={index}>
        <Styled.LabelAndValueWrapper>
          <Styled.Value>{data.id ? localizedNameObject(data).localizedFullName : t('buttons.leaveBlank')}</Styled.Value>
        </Styled.LabelAndValueWrapper>
      </Styled.OptionWrapper>
    );
  };
  return <DiffBase labelTransformer={labelTransformer} {...props} />;
};

export default EmployeeDtoCandidatePreofferInfoDiff;
